<template>
  <common-layout-template :bg_ground_gray="true" :isBread="true" :breadHeading="'資料請求・お問い合わせ'">
    <template v-slot:body>
      <div class="c-researve">
        <h1>資料請求</h1>
        <search-loading v-if="!isReady" />
        <p v-if="err.isErr" class="p-errmsg">
          <span>
            <img src="@/assets/attention.png" alt="エラー" width="22" height="22" />
          </span>
          {{ err.msg }}
        </p>
        <div v-show="isReady && !err.isErr">
          <figure>
            <img :src="getStep(page)">
          </figure>
          <dl v-if="page !== 'comp'" class="c-researve--list">
            <div class="c-researve--list--item">
              <dt>種別</dt>
              <dd>{{data.kind}}</dd>
            </div>
            <div class="c-researve--list--item">
              <dt>物件名</dt>
              <dd>{{data.propName}}</dd>
            </div>
            <div class="c-researve--list--item">
              <dt>会社名/店舗名</dt>
              <dd>{{data.company}}</dd>
            </div>
          </dl>
          <document-request-form
            v-if="isReady"
            v-show="page === 'form'"
            :page="page"
            :userData="userData"
            :prefList="prefList"
            :data="data"
            :isReady="isReady"
            @ready="isReady = true"
            :err="err"
            @user-data-loaded="isUserDataLoaded = true"
            @input="page = $event"
          />
          <document-request-confirm
            v-if="page === 'conf'"
            :page="page"
            :data="data"
            :isLoading="isLoading"
            :prefList="prefList"
            :err="formErr"
            @submit="submit"
            @input="page = $event"
          />

          <document-request-complete
            v-if="page === 'comp'"
          />

        </div>
      </div>
    </template>
  </common-layout-template>
</template>

<script>
import { sendDocumentRequest } from '@/api/inquiry-email';
import axios from 'axios';

import MixinAPI from '@/plugins/mixin-api';
import IsMobileMixin from '@/plugins/isMobile';
import Meta from '@/plugins/mixin-meta';

import DocumentRequestForm from '@/components/reservation/document-request/DocumentRequestForm';
import DocumentRequestConfirm from '@/components/reservation/document-request/DocumentRequestConfirm';
import DocumentRequestComplete from '@/components/reservation/document-request/DocumentRequestComplete';
import SearchLoading from '@/components/search/kodate/SearchLoading';
import CommonLayoutTemplate from '@/components/templates/CommonLayoutTemplate';

import step1 from '@/assets/reservation-spep-1.png';
import step2 from '@/assets/reservation-spep-2.png';
import step3 from '@/assets/reservation-spep-3.png';

export default {
  name: 'DocumentRequest',
  mixins: [MixinAPI, IsMobileMixin, Meta],
  components: {
    DocumentRequestForm,
    DocumentRequestConfirm,
    DocumentRequestComplete,
    SearchLoading,
    CommonLayoutTemplate,
  },
  data() {
    return {
      step: this.getStep(),
      page: 'form',
      isLoading: false,
      isReady: false,
      err: {
        isErr: false,
        msg: '',
      },
      formErr: {
        isErr: false,
        msg: '',
      },
      query: {
        ispage: null,
      },
      userData: {
      },
      prefList: [],
      propertyData: {},
      data: {
        name: '',
        kana: '',
        email: '',
        zip: '',
        pref: '',
        city: '',
        building: '',
        tel: '',
        kind: '',
        propName: '',
        company: '',
        priority: '',
        isLoadedOnce: false,
      },
    };
  },

  computed: {
    isLoggedIn() {
      return this.$store.state.user;
    },
  },
  async created() {
    this.metaSetForDefault('documentRequest');
    this.hydrateData();
    // Footer表示フラグ更新
    await this.$store.commit('setFooterDisplayFlag');
  },
  methods: {
    // 物件データ取得
    async hydrateData() {
      try {
        this.propertyData = await this.fetchPropertyData();
        this.prefList = await this.getPrefectureList();

        // ユーザーデータ取得
        if (this.isLoggedIn) await this.getUserData();
        this.data.id = this.isValued(this.propertyData.data.id);
        this.data.kind = this.isValuedKind(this.propertyData.data.kind);
        this.data.propName = this.isValued(this.propertyData.data.name);
        this.data.priority = this.isValued(+this.propertyData.data.priority);
        this.data.company = this.isValued(this.propertyData.data.contact_name);
        this.data.contactEmail = this.isValued(this.propertyData.data.contact_email2);
        this.isReady = true;
      } catch (e) {
        this.err.isErr = true;
        this.err.msg = 'エラーが発生しました';
      }
    },
    async fetchPropertyData() {
      try {
        return await this.getPropertyData(this.$route.params.propertyid);
      } catch (e) {
        let msg;
        if (e.response.status === 404) {
          msg = '物件が見つかりませんでした。';
        } else {
          msg = 'エラーが発生しました。もう一度やり直してください。';
        }
        throw new Error(msg);
      }
    },
    async fetchPrefectures() {
      try {
        this.prefList = await this.getPrefectureList();
      } catch (error) {
        const msg = 'エラーが発生しました。もう一度やり直してください。';
        throw new Error(msg);
      }
    },
    getStep(step) {
      let ret;
      if (step === 'form') ret = step1;
      if (step === 'conf') ret = step2;
      if (step === 'comp') ret = step3;

      return ret;
    },
    async getUserData() {
      this.err.isErr = false;
      this.err.msg = '';
      try {
        const userData = await this.$store.state.user;
        this.userData = {
          sei: userData.user_metadata.family_name,
          mei: userData.user_metadata.given_name,
          seikana: userData.user_metadata.phonetic_family_name,
          meikana: userData.user_metadata.phonetic_given_name,
          zip: userData.user_metadata.postal,
          address: userData.user_metadata.prefecture && userData.user_metadata.address ? userData.user_metadata.address : '',
          addressLocal: userData.user_metadata.building,
          email: userData.email,
          tel: userData.user_metadata.raw_phone_number ? `0${userData.user_metadata.raw_phone_number.slice(4, userData.user_metadata.raw_phone_number.length)}` : '',
          prefecture: userData.user_metadata.prefecture || '',
        };
      } catch (e) {
        this.err.isErr = true;
        this.err.msg = 'ユーザー情報取得にエラーが発生しました。';
      }
    },
    async submit() {
      const requestBody = {
        user: {
          name: this.data.name,
          email: this.data.email,
          kana: this.data.kana,
          tel: this.data.tel,
          zip: this.data.zip,
          address: this.data.pref + this.data.city + this.data.building,
        },
        property: {
          id: this.data.id,
          name: this.data.propName,
          company: this.data.company,
          priority: this.data.priority,
        },
      };
      const params = new URLSearchParams();
      params.append('id', this.data.id);
      params.append('propname', this.data.propName);
      params.append('company', this.data.company);
      params.append('name', this.data.name);
      params.append('kana', this.data.kana);
      params.append('email', this.data.email);
      params.append('tel', this.data.tel);
      params.append('address', this.data.zip + this.data.pref + this.data.city + this.data.building);
      params.append('priority', this.data.priority);
      params.append('want', this.data.want);
      params.append('ccmail', this.data.contactEmail);

      try {
        this.isLoading = true;
        let uri;
        if (process.env.VUE_APP_ENV === 'prod') {
          uri = 'https://ki-group.jp/mitsukaru/document_request.php'; // 本番環境
        } else {
          uri = 'https://ki-group.jp/mitsukaru/document_request_dev.php';// 開発環境
        }
        await sendDocumentRequest(requestBody);
        await axios.post(uri, params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
        this.page = 'comp';
      } catch (e) {
        this.formErr.isErr = true;
        this.formErr.msg = 'エラーが発生しました。';
      } finally {
        this.isLoading = false;
      }
    },
    isValuedKind(val, sep = '-') {
      let ret = sep;
      if (val === 'newly-house' || val === '新築一戸建て') {
        ret = '新築一戸建て';
      } else if (val === 'second-hand-house' || val === '中古一戸建て') {
        ret = '中古一戸建て';
      }
      return ret;
    },
    isValued(val, sep = '-') {
      return val !== undefined ? val : sep;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/style/contact/base_scss.scss";

</style>
